import curry from 'shadow-fns/src/curry'
import isObject from './isObject'
import isFunction from './isFunction'

const hasFunction = curry((f, o) => isObject(o) && isFunction(o[f]))
export default hasFunction
